import { NSTable } from 'bricks';
import { IPartnerReturns } from 'views/Reports/types';
import { transfortmPartnerReturnsData } from 'views/Reports/ReportTypes/AggregateReport/helpers';
import ExpandableRow from './ExpandableRow';

export interface IPartnerReturnsTableProps {
    data: IPartnerReturns;
}

const PartnerReturnsTable = ({ data }: IPartnerReturnsTableProps) => {
    const formattedPartnerReturns = transfortmPartnerReturnsData(data);

    return (
        <>
            <h4 className="text-white mt-1">Partner returns</h4>
            <NSTable className="NSTable mb-1">
                <thead>
                    <tr>
                        <th className="NSTable__thead__tr align-middle text-white" key="partner-returns-summary-header">Summary</th>
                        <th className="NSTable__thead__tr align-middle text-white" key="partner-returns-contributions-header">Contributions</th>
                        <th className="NSTable__thead__tr align-middle text-white" key="partner-returns-netprofit-header">Net profit</th>
                        <th className="NSTable__thead__tr align-middle text-white" key="partner-returns-roi-header">ROI</th>
                        <th className="NSTable__thead__tr align-middle text-white" key="partner-returns-emx-header">EMx</th>
                        <th className="NSTable__thead__tr align-middle text-white" key="partner-returns-irr-header">IRR</th>
                    </tr>
                </thead>
                <tbody>
                    <ExpandableRow partnerType="General Partner" data={formattedPartnerReturns.gp} />
                    <ExpandableRow partnerType="Limited Partner" data={formattedPartnerReturns.lp} />
                </tbody>
            </NSTable>
        </>
    );
};

export default PartnerReturnsTable;
